import Lenis from 'lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const lenis = (): void => {
  const lenis = new Lenis()

  function raf(time = 0) {
    lenis.raf(time)
    ScrollTrigger.update()
    requestAnimationFrame(raf)
  }

  lenis.on('scroll', ScrollTrigger.update)

  gsap.ticker.add(time => {
    lenis.raf(time * 1000)
  })

  gsap.ticker.lagSmoothing(0)

  requestAnimationFrame(raf)

  lenis.scrollTo(0);

  // Tell ScrollTrigger how to get/set scroll values from Lenis
  ScrollTrigger.scrollerProxy(document.body, {
    scrollTop(value?: number): number | void {
      if (typeof value === 'number') {
        // If a value is passed in, scroll to it using Lenis
        window.scrollTo(0, value)
      } else {
        // Otherwise, return the current scrollY
        return window.scrollY
      }
    },
    getBoundingClientRect(): DOMRect {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        bottom: window.innerHeight,
        right: window.innerWidth,
        x: 0,
        y: 0,
        toJSON() {
          return {}
        }
      }
    },
    // Required if Lenis applies transform on <html> or <body>
    pinType: document.documentElement.style.transform ? "transform" : "fixed"
  })

  // ScrollTrigger.normalizeScroll(true)
}
